export default "__VITE_ASSET__B9A$MQBn__"